const constants = {
	BABY_FOOTBALL_DEFAULT_TOURNAMENT_IMAGE: `${process.env.REACT_APP_URL}/images/super-liga.png`,
	IMAGE_YET_NOT_UPLOADED_ID: -1,
	MAX_COVER_IMAGE_SIZE: 2048,
};

export default constants;
